// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Q5wEE","header":"ReportDetails_header__1AXsm","title":"ReportDetails_title__3rYzd","left":"ReportDetails_left__2GgKf"};